export const BARSCHARTS = [
    {dataKey:'porcControl', fill:'#70AF52'},
    {dataKey:'porcUtilidad',fill:'#E09A05'}
]